// extracted by mini-css-extract-plugin
export default {"tooltip":"link-to-post-tooltip_tooltip__SdXjJ","content":"link-to-post-tooltip_content__5WSPY","arrow":"link-to-post-tooltip_arrow__xbuKA"};